import i18next from 'i18next'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import httpBackend from 'i18next-http-backend/cjs'
// import { initReactI18next } from 'react-i18next'
import { getLegacyWebsiteUrl } from 'utils'

const defaultLanguage = process.env.REACT_APP_LANGUAGE || 'pt'
const supportedLanguages = ['pt', 'en', 'es']
const dayjsLocales = { pt: 'pt-br', en: 'en', es: 'es' }

// REACT_APP_LANGUAGE is the source of truth; `?lng=` overrides it for debugging only.
const getLanguage = () => {
  const queryLanguage = new URLSearchParams(window.location.search).get('lng')
  return supportedLanguages.includes(queryLanguage) ? queryLanguage : defaultLanguage
}

const initI18n = () =>
  i18next
    // .use(httpBackend)
    // .use(initReactI18next)
    .init({
      lng: getLanguage(),
      fallbackLng: defaultLanguage,
      debug: process.env.NODE_ENV === 'development',
      resources: {
        pt: {
          translation: {
            loading: 'Carregando...',
            auth: {
              changeEmail: 'Trocar e-mail',
              loginTitle: 'Digite seu e-mail',
              passwordTitle: 'Digite sua senha',
              signUpTitle: 'Informe seus dados',
              nextPageText: 'Você tentou acessar a página: {{page}}. sem estar logado',
              email: 'E-mail',
              password: 'Sua senha',
              passwordRequired: 'Digite sua senha para entrar',
              passwordMinLength: 'Sua senha deve ter pelo menos 3 digitos',
              passwordMinLength4: 'Sua senha deve ter pelo menos 4 digitos',
              passwordRequiredSignUp: 'Digite sua senha para se cadastrar',
              emailValid: 'Digite um e-mail válido',
              emailRequired: 'Digite seu e-mail para continuar',
              requireField: 'Campo obrigatório',
              nameRequied: 'Digite nome e sobrenome',
              phoneNumberIncomplete: 'Número de telefone incompleto',
              phoneNumberTooShort: 'Número muito curto. Digite um número válido',
              phoneNumberTooLong: 'Número muito longo. Digite um número válido',
              phoneNumberInvalid: 'Digite um número válido',
              solveCaptcha: 'Resolva o Recaptcha para concluir',
              acceptTerms: 'Você precisa aceitar os termos',
              acceptPrivacy: 'Você precisa aceitar a política de privacidade',
              forgotPassword: 'Esqueceu sua senha?',
              signUpSubtitle: 'Digite as informações abaixo para completar o cadastro:',
              fullName: 'Nome completo',
              cellphone: 'Celular (De preferência WhatsApp)',
              gender: 'Gênero',
              notInformed: 'Não informado',
              male: 'Masculino',
              female: 'Feminino',
              setPassword: 'Crie sua senha',
              signIn: 'Entrar',
              continue: 'Continuar',
              finishSignUp: 'Concluir cadastro',
              updateEmail: 'Atualizar e-mail',
              updateYourPassword: 'Atualize sua senha',
              changeName: 'Alterar nome',
              updateProfile: 'Atualizar perfil',
              currentPhoneNumber: 'Número de celular atual',
              messages: {
                signUpError: 'Não foi possível efetuar o cadastro',
                signUpSuccess: 'Cadastro efetuado com sucesso!',
                signInError: 'E-mail ou senha incorreta',
                signInSuccess: 'Login efetuado com sucesso!',
                updateProfileSuccess: 'Cadastro atualizado com sucesso!',
              },
              phoneIdYes: 'Sim, receber via SMS',
              phoneIdNo: 'Não, fechar',
              smsOtpTitle: 'Faça login com código',
              smsOtpDescription: 'Enviamos um código de 4 digitos para o seu telefone:',
              smsOtpDidntReceive: 'Não recebeu o código?',
              smsOtpResend: 'Reenviar código',
              smsOtpResendIn: 'Reenviar em',
              updateProfileTitle: 'Atualize seu cadastro',
              updateProfileDescription:
                'Confirme suas informações abaixo para atualizar o cadastro:',
            },
            chat: {
              title: 'Chat',
              conversations: 'Conversas',
              contacts: 'Contatos',
              connecting: 'Estabelecendo conexão...',
              subscribeToInteract: 'Assine agora para interagir no chat',
              sendMessage: 'Enviar mensagem',
              addContact: 'Adicionar contato',
              addToContacts: 'Adicionar aos contatos',
              removeContact: 'Remover contato',
              noMessagesTitle: 'Nenhuma mensagem ainda.',
              noMessagesDescription: 'Diga alguma coisa e inicie a conversa.',
              noMoreMessages: 'Não existe mais mensagens',
              inputPlaceholder: 'Escreva aqui sua mensagem...',
              picker: {
                search: 'Buscar',
                clear: 'Limpar',
                notFound: 'Nenhum emoji encontrado',
                skinText: 'Escolha o tom de pele padrão',
                categoriesLabel: 'Categorias de Emojis',
                categories: {
                  search: 'Resultados da busca',
                  recent: 'Usados frequentemente',
                  smileys: 'Sorrisos e emoção',
                  people: 'Pessoas',
                  nature: 'Animais e natureza',
                  foods: 'Comida e bebida',
                  activity: 'Atividades',
                  places: 'Viagem e lugares',
                  objects: 'Objetos',
                  symbols: 'Símbolos',
                  flags: 'Bandeiras',
                  custom: 'Personalizado',
                },
                skinTones: {
                  1: 'Tom de pele padrão',
                  2: 'Tom de pele claro',
                  3: 'Tom de pele médio-claro',
                  4: 'Tom de pele médio',
                  5: 'Tom de pele médio escuro',
                  6: 'Tom de pele escura',
                },
              },
            },
          },
        },
        en: {
          translation: {
            loading: 'Loading...',
            auth: {
              changeEmail: 'Change email',
              loginTitle: 'Enter your email',
              passwordTitle: 'Enter your password',
              signUpTitle: 'Enter your details',
              nextPageText: 'You tried to access the page: {{page}}. without being logged in',
              email: 'Email',
              password: 'Your password',
              passwordRequired: 'Enter your password to log in',
              passwordMinLength: 'Your password must have at least 3 digits',
              passwordMinLength4: 'Your password must have at least 4 digits',
              passwordRequiredSignUp: 'Enter your password to sign up',
              emailValid: 'Enter a valid email',
              emailRequired: 'Enter your email to continue',
              requireField: 'Required field',
              nameRequied: 'Enter first and last name',
              phoneNumberIncomplete: 'Incomplete phone number',
              phoneNumberTooShort: 'Too short number. Enter a valid number',
              phoneNumberTooLong: 'Too long number. Enter a valid number',
              phoneNumberInvalid: 'Enter a valid number',
              solveCaptcha: 'Solve the Recaptcha to complete',
              acceptTerms: 'You need to accept the terms',
              acceptPrivacy: 'You need to accept the privacy policy',
              forgotPassword: 'Forgot your password?',
              signUpSubtitle: 'Enter the information below to complete the registration:',
              fullName: 'Full name',
              cellphone: 'Cellphone (Preferably WhatsApp)',
              gender: 'Gender',
              notInformed: 'Not informed',
              male: 'Male',
              female: 'Female',
              setPassword: 'Create your password',
              signIn: 'Sign In',
              continue: 'Continue',
              finishSignUp: 'Finish registration',
              updateEmail: 'Update email',
              updateYourPassword: 'Update your password',
              changeName: 'Change name',
              updateProfile: 'Update profile',
              currentPhoneNumber: 'Current phone number',
              messages: {
                signUpError: 'Could not register',
                signUpSuccess: 'Registration successful!',
                signInError: 'Incorrect email or password',
                signInSuccess: 'Login successful!',
                updateProfileSuccess: 'Profile updated successfully!',
              },
              phoneIdYes: 'Yes, receive via SMS',
              phoneIdNo: 'No, close',
              smsOtpTitle: 'Log in with code',
              smsOtpDescription: 'We sent a 4-digit code to your phone:',
              smsOtpDidntReceive: "Didn't receive the code?",
              smsOtpResend: 'Resend code',
              smsOtpResendIn: 'Resend in',
              updateProfileTitle: 'Update your profile',
              updateProfileDescription: 'Confirm your information below to update your profile:',
            },
            chat: {
              title: 'Chat',
              conversations: 'Conversations',
              contacts: 'Contacts',
              connecting: 'Establishing connection...',
              subscribeToInteract: 'Subscribe now to interact in the chat',
              sendMessage: 'Send message',
              addContact: 'Add contact',
              addToContacts: 'Add to contacts',
              removeContact: 'Remove contact',
              noMessagesTitle: 'No messages yet.',
              noMessagesDescription: 'Say something to start the conversation.',
              noMoreMessages: 'No more messages',
              inputPlaceholder: 'Write your message here...',
              picker: {
                search: 'Search',
                clear: 'Clear',
                notFound: 'No emoji found',
                skinText: 'Choose your default skin tone',
                categoriesLabel: 'Emoji categories',
                categories: {
                  search: 'Search results',
                  recent: 'Frequently used',
                  smileys: 'Smileys & emotion',
                  people: 'People',
                  nature: 'Animals & nature',
                  foods: 'Food & drink',
                  activity: 'Activity',
                  places: 'Travel & places',
                  objects: 'Objects',
                  symbols: 'Symbols',
                  flags: 'Flags',
                  custom: 'Custom',
                },
                skinTones: {
                  1: 'Default skin tone',
                  2: 'Light skin tone',
                  3: 'Medium-light skin tone',
                  4: 'Medium skin tone',
                  5: 'Medium-dark skin tone',
                  6: 'Dark skin tone',
                },
              },
            },
          },
        },
        es: {
          translation: {
            loading: 'Cargando...',
            auth: {
              changeEmail: 'Cambiar correo electrónico',
              loginTitle: 'Ingresa tu correo electrónico',
              passwordTitle: 'Ingresa tu contraseña',
              signUpTitle: 'Ingresa tus datos',
              nextPageText: 'Intentaste acceder a la página: {{page}}. sin haber iniciado sesión',
              email: 'Correo electrónico',
              password: 'Tu contraseña',
              passwordRequired: 'Ingresa tu contraseña para iniciar sesión',
              passwordMinLength: 'Tu contraseña debe tener al menos 3 dígitos',
              passwordMinLength4: 'Tu contraseña debe tener al menos 4 dígitos',
              passwordRequiredSignUp: 'Ingresa tu contraseña para registrarte',
              emailValid: 'Ingresa un correo electrónico válido',
              emailRequired: 'Ingresa tu correo electrónico para continuar',
              requireField: 'Campo obligatorio',
              nameRequied: 'Ingresa nombre y apellido',
              phoneNumberIncomplete: 'Número de teléfono incompleto',
              phoneNumberTooShort: 'Número demasiado corto. Ingresa un número válido',
              phoneNumberTooLong: 'Número demasiado largo. Ingresa un número válido',
              phoneNumberInvalid: 'Ingresa un número válido',
              solveCaptcha: 'Resuelve el Recaptcha para completar',
              acceptTerms: 'Debes aceptar los términos',
              acceptPrivacy: 'Debes aceptar la política de privacidad',
              forgotPassword: '¿Olvidaste tu contraseña?',
              signUpSubtitle: 'Ingresa la información a continuación para completar el registro:',
              fullName: 'Nombre completo',
              cellphone: 'Teléfono celular (Preferiblemente WhatsApp)',
              gender: 'Género',
              notInformed: 'No informado',
              male: 'Masculino',
              female: 'Femenino',
              setPassword: 'Crea tu contraseña',
              signIn: 'Iniciar sesión',
              continue: 'Continuar',
              finishSignUp: 'Finalizar registro',
              updateEmail: 'Actualizar correo electrónico',
              updateYourPassword: 'Actualizar tu contraseña',
              changeName: 'Cambiar nombre',
              updateProfile: 'Actualizar perfil',
              currentPhoneNumber: 'Número de teléfono actual',
              messages: {
                signUpError: 'No se pudo registrar',
                signUpSuccess: '¡Registro exitoso!',
                signInError: 'Correo electrónico o contraseña incorrecta',
                signInSuccess: '¡Inicio de sesión exitoso!',
                updateProfileSuccess: '¡Perfil actualizado con éxito!',
              },
              phoneIdYes: 'Sí, recibir por SMS',
              phoneIdNo: 'No, cerrar',
              smsOtpTitle: 'Inicia sesión con código',
              smsOtpDescription: 'Enviamos un código de 4 dígitos a tu teléfono:',
              smsOtpDidntReceive: '¿No recibiste el código?',
              smsOtpResend: 'Reenviar código',
              smsOtpResendIn: 'Reenviar en',
              updateProfileTitle: 'Actualiza tu registro',
              updateProfileDescription:
                'Confirma tu información a continuación para actualizar tu perfil:',
            },
            chat: {
              title: 'Chat',
              conversations: 'Conversaciones',
              contacts: 'Contactos',
              connecting: 'Estableciendo conexión...',
              subscribeToInteract: 'Suscríbete ahora para interactuar en el chat',
              sendMessage: 'Enviar mensaje',
              addContact: 'Agregar contacto',
              addToContacts: 'Agregar a contactos',
              removeContact: 'Eliminar contacto',
              noMessagesTitle: 'Aún no hay mensajes.',
              noMessagesDescription: 'Di algo para iniciar la conversación.',
              noMoreMessages: 'No hay más mensajes',
              inputPlaceholder: 'Escribe aquí tu mensaje...',
              picker: {
                search: 'Buscar',
                clear: 'Limpiar',
                notFound: 'No se encontró ningún emoji',
                skinText: 'Elige tu tono de piel predeterminado',
                categoriesLabel: 'Categorías de emojis',
                categories: {
                  search: 'Resultados de búsqueda',
                  recent: 'Usados con frecuencia',
                  smileys: 'Emoticonos y emociones',
                  people: 'Personas',
                  nature: 'Animales y naturaleza',
                  foods: 'Comida y bebida',
                  activity: 'Actividades',
                  places: 'Viajes y lugares',
                  objects: 'Objetos',
                  symbols: 'Símbolos',
                  flags: 'Banderas',
                  custom: 'Personalizado',
                },
                skinTones: {
                  1: 'Tono de piel predeterminado',
                  2: 'Tono de piel claro',
                  3: 'Tono de piel medio claro',
                  4: 'Tono de piel medio',
                  5: 'Tono de piel medio oscuro',
                  6: 'Tono de piel oscuro',
                },
              },
            },
          },
        },
      },
    })
    .then(t => {
      dayjs.locale(dayjsLocales[i18next.language] || dayjsLocales[defaultLanguage])
      return t
    })

export default initI18n
